import React, { FunctionComponent, useEffect, useRef, useState, } from "react";
import { connect, useDispatch } from "react-redux";
import WhatsappMessagePreview from "../../Components/MarketingAutomation/WhatsappMessagePreview/WhatsappMessagePreview";
import DispositionWhatsappTemplates from "../../Components/MarketingAutomation/DispositionWhatsappTemplates/DispositionWhatsappTemplates";
import styles from "./Templates.module.css";
import { AiOutlineSearch } from 'react-icons/ai';
// import CheckIcon from '@mui/icons-material/Check';
import TemplateSearch from "../../Components/TemplateSearch/TemplateSearch";
import { useHistory } from "react-router-dom"; 
import { fetchOrgDispositionConfig } from "../../Services/organizations";

type props = {
    title?: string
    organizationId: string
    accessAllowedMarketingAutomation: any
    history: any;
};

const Templates: FunctionComponent<props> = ({ organizationId, accessAllowedMarketingAutomation, history }) => {

    const [selectedTemplates, setSelectedTemplates] = useState("Disposition based");
    const [orgConfigTemplates,setOrgConfigTemplates] = useState([]);

    const dispatcher = useDispatch();
    const navigate = useHistory();

    // const BubbleTabBar: FunctionComponent<{ title: string }> => {
    const BubbleTabBar: FunctionComponent<{ title: string }> = ({ title }) => {
        return (
            <div className={selectedTemplates == title ? styles.bubbleTabBar : styles.bubbleTabBarInactive}
                onClick={() => {
                    setSelectedTemplates(title);
                }}
            >
                {/* <div className={styles.tickShape}>✔</div> */}
                <p>{title}</p>
            </div>
        )
    }

    useEffect(() => {
        if (accessAllowedMarketingAutomation === false) {
            history.push("/");
        }
    }, [accessAllowedMarketingAutomation])

    useEffect(()=>{
        fetchOrgDispositionConfig(organizationId,setOrgConfigTemplates);
    },[organizationId])

    return (
        accessAllowedMarketingAutomation && (
            <div className={styles.templatesContainer}>
                <div className={styles.templatesContent}>
                    <h1>Templates</h1>
                    <div className={'Breadcrums'}>
                        <span className={"BreadcrumsPath"}
                            onClick={() => {
                                navigate.push("/marketing");
                            }}
                        >Marketing</span>
                        <span className={"BreadcrumsPath"}>Templates</span>
                    </div>
                </div>
                <div className={styles.templateTabsContainer}>
                    <div className={styles.templateTypeTabs}>
                        <BubbleTabBar title="Disposition based" />
                        <BubbleTabBar title="Broadcast Message" />
                    </div>
                    {/* <TemplateSearch /> */}
                </div>
                <DispositionWhatsappTemplates selectedTemplatesType={selectedTemplates} orgConfigTemplates={orgConfigTemplates} />
                {/* <div className={styles.saveContainer}>
                <div className={styles.saveSubContainer}>
                    <p>Note : Plan will only get activated once template setup is complete for each lead status.</p>
                    <button className={styles.saveButton}>Save & Submit</button>
                </div>
            </div> */}
            </div>
        )
    );
};

const mapStateToProps = (state: any) => {
    return {
        organizationId: state.organization.id,
        accessAllowedMarketingAutomation: state.organization.accessAllowedMarketingAutomation
    };
};

export default connect(mapStateToProps)(Templates);